OrderReturn = function () {
    var init = function () {
        var config = document.getElementById('order-return-config');

        if (!config) {
            return;
        }

        var statusUrl   = config.getAttribute('data-status-url');
        var maxAttempts = parseInt(config.getAttribute('data-max-attempts'), 10) || 120;
        var interval    = parseInt(config.getAttribute('data-interval'), 10)    || 5000;
        var attempts    = 0;
        var timer;

        function checkStatus() {
            attempts++;

            var xhr = new XMLHttpRequest();
            xhr.open('GET', statusUrl, true);
            xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
            xhr.onload = function () {
                if (xhr.status === 200) {
                    try {
                        var data = JSON.parse(xhr.responseText);
                        if (data.status === 'paid') {
                            clearInterval(timer);
                            showPaid(data.tickets_url);
                            return;
                        }
                    } catch (e) {}
                }
                if (attempts >= maxAttempts) {
                    clearInterval(timer);
                    showWarning();
                }
            };
            xhr.onerror = function () {
                if (attempts >= maxAttempts) {
                    clearInterval(timer);
                    showWarning();
                }
            };
            xhr.send();
        }

        function showPaid(ticketsUrl) {
            document.getElementById('status-pending').classList.add('hidden');
            document.getElementById('status-warning').classList.add('hidden');
            var paidBlock = document.getElementById('status-paid');
            paidBlock.classList.remove('hidden');
            var emailBlock = document.getElementById('status-email');
            if (emailBlock) {
                emailBlock.classList.remove('hidden');
            }
            if (ticketsUrl) {
                document.getElementById('btn-download-tickets').href = ticketsUrl;
            }
            paidBlock.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }

        function showWarning() {
            document.getElementById('status-warning').classList.remove('hidden');
        }

        timer = setInterval(checkStatus, interval);
        checkStatus();
    };

    return {
        init: function () {
            init();
        }
    };
}();

if (typeof OrderReturn !== 'undefined') {
    OrderReturn.init();
}
